module.exports = __webpack_public_path__ + "img/login-aside.d50fca9f.svg";